import React from 'react'
import PropTypes from 'prop-types'
import { DetailRow } from '../../PaymentResult/PaymentSuccess'

export default function Card(props) {
    const primaryColor = props.primaryColor || '#334155'

    return (
        <>
            <DetailRow label="Cardholder Number" value={props.data.cardholderNumber} primaryColor={primaryColor} />
            <DetailRow label="Expiry Date (mm/yy)" value={props.data.expiryDate} primaryColor={primaryColor} />
        </>
    )
}

Card.propTypes = {
    primaryColor: PropTypes.string,
    data: PropTypes.shape({
        cardholderNumber: PropTypes.string.isRequired,
        expiryDate: PropTypes.string.isRequired,
    }).isRequired,
}
